import React from 'react';
import {
    Box,
    Typography,
    Button,
    Drawer
} from '@mui/material';
import ChartSettings from '../chartSettings/ChartSettings';

function MobileChartSettingsDrawer({
    isMobile,
    drawerOpen,
    onClose,
    onSave,
    routeData
}) {
    return (
        <Drawer
            anchor="bottom"
            open={isMobile && drawerOpen}
            onClose={onClose}
            variant="temporary"
            PaperProps={{
                sx: {
                    height: '80vh',
                    maxHeight: '80vh',
                    width: '100%',
                    maxWidth: '100%',
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                }
            }}
        >
            <Box sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            }}>
                <Box sx={{
                    p: 2,
                    borderBottom: 1,
                    borderColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Typography variant="h6">Route Configuration</Typography>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onSave}
                    >
                        {routeData?.isCached ? "Save" : "Apply"}
                    </Button>
                </Box>
                <Box sx={{ flex: 1, overflow: 'auto' }}>
                    <ChartSettings />
                </Box>
            </Box>
        </Drawer>
    );
}

export default MobileChartSettingsDrawer;
